import { useState } from "react";
import WalletPubListItem from "../pub-list-item";
import {
  WalletPubListAreaItem,
  WalletPubListAreaName,
  WalletPubListWrapper,
} from "./style";
import { WalletNoData } from "../../../../style";
import WalletPubListSkeleton from "./skeleton";
import { useWalletContext } from "../../../../hooks/wallet-context";

const WalletPubList = () => {
  const { walletList, walletLoading } = useWalletContext();
  const [selectedId, setSelectedId] = useState(-1);

  if (walletLoading) return <WalletPubListSkeleton />;

  return (
    <WalletPubListWrapper>
      {walletList.length !== 0 ? (
        walletList.map((item, index) => (
          <WalletPubListAreaItem key={index}>
            <WalletPubListAreaName>{item.area}</WalletPubListAreaName>
            {item.cafes.map((pub, i) => (
              <WalletPubListItem
                key={i}
                item={pub}
                setSelectedId={setSelectedId}
                isSelected={selectedId === pub.id}
              />
            ))}
          </WalletPubListAreaItem>
        ))
      ) : (
        <WalletNoData>이용중인 매장이 없습니다. </WalletNoData>
      )}
    </WalletPubListWrapper>
  );
};

export default WalletPubList;
